import React, { useEffect, useState } from "react";
import { Container } from "../components/Grid";
import { Link, useParams } from "react-router-dom";
import API from "../utils/API";
import UserSplash from "../components/UserSplash/UserSplash";
import MusicBtn from "../components/SoundBtns/MusicBtn";
import "./User.css";

function User() {
  let { id } = useParams();

  const [useContinueButton, setContinueButton] = useState(null);

  useEffect(() => {
    async function continueCheck() {

        const getUserData = async ()=> {
            const userData = await API.getUser(id)
            const user = await userData.json()

            if (!user.sprite[0]){
                setContinueButton(false);
            }else {
                setContinueButton(true);
            }
         
            // setUserAvatarName(user.sprite[0])
            
        }
  

        getUserData().catch(() => setContinueButton(false));
  
    }
    continueCheck();
  }, [id]);

  return (
    <Container>
      <main className="realm-page">
        <MusicBtn />
        <header className="realm-header">
          <p className="realm-eyebrow"><span aria-hidden="true">✦</span> Your storybook home</p>
          <h1>Welcome to Your Realm</h1>
          <p className="realm-subtitle">The next chapter is waiting for you.</p>
        </header>

        <div className="realm-grid">
          <section className="realm-visual" aria-label="Your storybook realm">
            <div className="realm-visual__frame">
              <UserSplash />
              <span className="realm-spark realm-spark-one" aria-hidden="true">✦</span>
              <span className="realm-spark realm-spark-two" aria-hidden="true">✧</span>
            </div>
            <p className="realm-caption">Every great adventure starts with a single page.</p>
          </section>

          <section className="realm-menu" aria-labelledby="realm-menu-title">
            <div className="realm-menu__topline" aria-hidden="true"><span>✦</span><span>✧</span><span>✦</span></div>
            <p className="realm-eyebrow">Your adventure awaits</p>
            <h2 id="realm-menu-title">Choose your chapter</h2>
            <p className="realm-menu__copy">Continue a saved adventure or begin a brand-new tale in the learning realm.</p>
            <img className="realm-book" src={require("../images/Book-Pile.png")} alt="A pile of adventure books" />

            <div className="realm-actions">
              {useContinueButton ? (
                <Link className="realm-action realm-action--primary" to={"/continue/" + id}>
                  <span className="realm-action__title">Continue your Adventure</span>
                  <span className="realm-action__hint">Pick up where you left off</span>
                </Link>
              ) : (
                <button type="button" disabled className="realm-action realm-action--primary realm-action--disabled">
                  <span className="realm-action__title">Continue your Adventure</span>
                  <span className="realm-action__hint">Create a story first</span>
                </button>
              )}
              <Link className="realm-action realm-action--secondary" to={"/new/" + id}>
                <span className="realm-action__title">Start a New Adventure</span>
                <span className="realm-action__hint">Choose a character and begin</span>
              </Link>
            </div>

            <div className="realm-menu__footer">
              <Link className="realm-logout" to="/">Return to the Gateway</Link>
            </div>
          </section>
        </div>
      </main>
    </Container>
  );
}

export default User;
